import {
	Container,
	Grid,
	Card,
	Typography,
	RadioGroup,
	FormControlLabel,
	Radio,
	Button,
	Snackbar,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import ButtonBase from "@material-ui/core/ButtonBase/ButtonBase";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { TestContext } from "../../contexts/TestContext";
import { UserContext } from "../../contexts/UserContext";
import "./TestPage.css";

const TestPage = (props) => {
	const history = useHistory();
	const location = useLocation();
	const questionArray = [...location.state.data.questions];
	const [currentQues, setQues] = useState(0);
	const [currentOpt, setOpt] = useState("");
	const { timer, open_time, remaining_time } = useContext(TestContext);
	const { autoLogOut } = useContext(UserContext);

	const [loading, setLoading] = useState(false);
	const [loadingSnack, setLoadingSnack] = useState(false);
	const [successSnackbar, setSuccessSnackbar] = useState(false);

	const handleSubmit = async (change) => {
		setLoading(true);
		const url = `${process.env.REACT_APP_BACKEND_URL}/question/save`;
		const token = localStorage.getItem("token");
		if (currentOpt === questionArray[currentQues].response) {
			if (change === 0) {
				backToSections();
			} else {
				if (questionArray[currentQues + change].response)
					setOpt(questionArray[currentQues + change].response);
				else setOpt("");
				setQues((prev) => prev + change);
			}
			setLoading(false);
			return;
		}

		setLoadingSnack(true);
		try {
			await axios
				.post(
					url,
					{
						questionId: questionArray[currentQues]._id,
						selectedOptionId: currentOpt,
					},
					{
						headers: {
							Authorization: `Bearer ${token}`,
						},
					}
				)
				.then((res) => {
					// console.log(res);
					setLoading(false);
					setLoadingSnack(false);
					setSuccessSnackbar(true);
					if (change === 0) {
						backToSections();
					} else {
						questionArray[currentQues].response = currentOpt;
						if (questionArray[currentQues + change].response)
							setOpt(questionArray[currentQues + change].response);
						else setOpt("");
						setQues((prev) => prev + change);
					}
				});
		} catch (error) {
			// console.log(error);
			setLoadingSnack(false);
			setLoading(false);
			if (error.response.status === 420) {
				autoLogOut();
			}
		}
	};

	const handleChange = (index) => {
		const change = index - currentQues;
		// console.log(index, change);
		if (change !== 0) handleSubmit(change);
	};

	const backToSections = () => {
		history.replace({
			pathname: `/test/sections`,
			state: {
				time: remaining_time,
				openTime: open_time,
			},
		});
	};

	useEffect(() => {
		if (questionArray.length > 0) {
			if (questionArray[0].response) setOpt(questionArray[0].response);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Container className="test-page">
			{questionArray.length > 0 ? (
				<Grid container>
					<Grid
						item
						container
						xs={12}
						style={{
							marginTop: 10,
							marginBottom: 15,
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						<Grid item xs={6}>
							<Button
								variant="outlined"
								color="secondary"
								style={{ float: "left", padding: "3px 15px !important" }}
								onClick={() => {
									handleSubmit(0);
								}}
							>
								{"<< Go to Sections"}
							</Button>
						</Grid>
						<Grid item xs={6}>
							<span style={{ float: "right" }}>{timer}</span>
						</Grid>
					</Grid>
					<Grid
						container
						item
						xs={12}
						md={3}
						style={{ marginTop: 10, flexDirection: "column" }}
					>
						<Grid item container>
							{questionArray.map((question, index) => (
								<Grid item key={question._id}>
									<ButtonBase
										className={
											index === currentQues
												? "q-link selected"
												: question.response
												? "q-link attempted"
												: "q-link"
										}
										onClick={() => {
											handleChange(index);
										}}
									>
										<Typography>{index + 1}</Typography>
									</ButtonBase>
								</Grid>
							))}
						</Grid>
						<Grid item container style={{ margin: "20px 10px" }}>
							<Grid item container xs={12}>
								<ButtonBase className="q-link demo selected" />
								<Typography variant="body2">Current Question</Typography>
							</Grid>
							<Grid item container xs={12}>
								<ButtonBase className="q-link demo attempted" />
								<Typography variant="body2">Attempted Question</Typography>
							</Grid>
							<Grid item container xs={12}>
								<ButtonBase className="q-link demo" />
								<Typography variant="body2">Unattempted Question</Typography>
							</Grid>
						</Grid>
					</Grid>
					<Grid item xs={12} md={9}>
						<Card className="question-panel">
							<Typography variant="body1" style={{ whiteSpace: "pre-wrap" }}>
								{questionArray[currentQues].directions}
							</Typography>
							<Typography
								variant="h6"
								style={{
									whiteSpace: "pre-wrap",
									fontWeight: "bolder",
									marginTop: "20px",
								}}
							>
								{questionArray[currentQues].text}
							</Typography>
							<br />
							<RadioGroup
								aria-label="Gender"
								name="gender1"
								value={currentOpt}
								onChange={(e) => {
									setOpt(e.target.value);
								}}
							>
								<FormControlLabel
									value={questionArray[currentQues].options.first._id}
									control={<Radio />}
									label={questionArray[currentQues].options.first.text}
									style={{ marginTop: "15px" }}
								/>
								<FormControlLabel
									value={questionArray[currentQues].options.second._id}
									control={<Radio />}
									label={questionArray[currentQues].options.second.text}
									style={{ marginTop: "15px" }}
								/>
								<FormControlLabel
									value={questionArray[currentQues].options.third._id}
									control={<Radio />}
									label={questionArray[currentQues].options.third.text}
									style={{ marginTop: "15px" }}
								/>
								<FormControlLabel
									value={questionArray[currentQues].options.fourth._id}
									control={<Radio />}
									label={questionArray[currentQues].options.fourth.text}
									style={{ marginTop: "15px" }}
								/>
								<Button
									style={{
										padding: "3px 15px !important",
										color: "#f4792a",
										borderRadius: 4,
									}}
									onClick={() => setOpt("")}
								>
									{"Clear Response"}
								</Button>
							</RadioGroup>
							<br />
							{currentQues === 0 ? (
								<></>
							) : (
								<Button
									variant="outlined"
									color="secondary"
									style={{ float: "left", padding: "3px 15px !important" }}
									onClick={() => handleSubmit(-1)}
									disabled={loading}
								>
									{"< Previous"}
								</Button>
							)}
							{currentQues < questionArray.length - 1 ? (
								<Button
									variant="outlined"
									color="secondary"
									style={{ float: "right", padding: "3px 15px !important" }}
									onClick={() => handleSubmit(1)}
									disabled={loading}
								>
									{"Next >"}
								</Button>
							) : (
								<Button
									variant="outlined"
									color="secondary"
									style={{ float: "right", padding: "3px 15px !important" }}
									onClick={() => {
										handleSubmit(0);
									}}
								>
									{"Save and Go back to Sections >"}
								</Button>
							)}
						</Card>
					</Grid>
				</Grid>
			) : (
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						alignContent: "center",
						height: "90vh",
					}}
				>
					<Typography color="secondary" variant="h3">
						Nothing to Show here
					</Typography>
					<Button
						variant="outlined"
						color="secondary"
						style={{ padding: "3px 15px !important" }}
						onClick={() => {
							backToSections();
						}}
					>
						{"<< Go to Sections"}
					</Button>
				</div>
			)}
			<Snackbar
				open={successSnackbar}
				onClose={() => setSuccessSnackbar(false)}
				autoHideDuration={2000}
			>
				<Alert severity="success" variant="filled">
					Answer saved successfully
				</Alert>
			</Snackbar>
			<Snackbar
				open={loadingSnack}
				onClose={() => setLoadingSnack(false)}
				autoHideDuration={4000}
			>
				<Alert severity="info" variant="filled">
					Saving your answer...
				</Alert>
			</Snackbar>
		</Container>
	);
};

export default TestPage;
